import Swal from 'sweetalert2';

export const SwalWithDefaults = Swal.mixin({
  confirmButtonText: 'OK',
  cancelButtonText: 'Annulla',
  position: 'center',
  showClass: { popup: 'swal2-noanimation' },
  hideClass: { popup: '' },
});